import React, {Component} from "react";
import {connect} from "react-redux";
import Source from "../items/Source";

import "./HomeSection.css";
import ExploreBtn from "../items/ExploreBtn";

class HomeSection extends Component {

  render() {
    const {title, source, children, explore, note} = this.props;
    let noteCmps = null;
    if (note && Array.isArray(note)) {
      noteCmps = note.map((x,ix) => <Source key={ix} text={x}/>);
    } else if (note) {
      noteCmps = <Source text={note}/>;
    }

    return (
      <div className="fow-home-section">
        <div className="fow-inner-container">
          <div className="fow-row fow-md-row-to-col">
            <div className="fow-col fow-col-1-3 fow-lg-col-1-2 fow-md-col-1 fow-home-section-title">
              <h2 className="fow-font-title fow-font-size-xxl">{title}</h2>
              {children[0]}
              <ExploreBtn link={explore} />
            </div>
            <div className="fow-col fow-col-2-3 fow-lg-col-1-2 fow-md-col-1 fow-home-section-children">
              {children[1]}
              {source &&
                <Source text={source}/>
              }
              {noteCmps}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(HomeSection);
